import React from 'react';

// SECURITY NOTE: This implementation appears secure against XSS/injection — ShortedLogo renders only
// static, hardcoded JSX text/styles with no props, no user-controlled data, and no
// dangerouslySetInnerHTML, so there is no untrusted input surface in this component.
// ⚡ SEVERITY: ⚪ INFO - 0%
const ShortedLogo = () => {
  return (
    <div style={{
      textAlign: 'center',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'center',
          fontFamily: 'Karasha, Poppins, sans-serif',
          fontWeight: 'normal',
          letterSpacing: '2px',
          lineHeight: '1',
          fontSize: 'clamp(1.4rem, 5vw, 2.5rem)',   // ← responsive size
        }}
      >
        <span style={{ color: '#000000' }}>J</span>
        <span
          className="victory-square"
          style={{
            position: 'relative',
            fontFamily: 'Karasha, Poppins, sans-serif',
            color: '#10b981',
            fontWeight: 'bold',
            textShadow: '0 1px 2px rgba(0,0,0,0.5)',
            fontSize: 'clamp(1.4rem, 5vw, 2.5rem)',  // ← matches parent
          }}
        >
          W
        </span>
      </div>
      <div
        style={{
          height: '2px',
          background: 'linear-gradient(90deg, transparent, #FDD835, transparent)',
          width: '60%',
          margin: '8px auto 0',
          borderRadius: '1px'
        }}
      />
    </div>
  );
};

export default ShortedLogo;
